<template>
  <div v-title :data-title="$route.name">
    <div
      v-if="offsetwidth > 850"
      style="
        width: 100%;
        overflow: hidden;
        position: relative;
        min-width: 1349px;
        margin-top: 65px;
        background-color: white !important;
      "
    >
      <div style="position: relative">
        <img
          style="width: 100%"
          src="../assets/Battertimg/PC/casetop.jpg"
          alt=""
        />
        <div
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white !important;
            text-align: center;
            z-index: 10;
            width: 100%;
          "
        >
          <div
            style="
              font-size: 48px;
              font-family: Cotyledon-Regular-bold;
              line-height: 1;
              margin-bottom: 8px;
              width: 100%;
              text-align: center;
            "
          >
            Case
          </div>
        </div>
      </div>
      <div style="width: 100%; text-align: center">
        <div
          style="
            position: relative;
            margin: 0;
            padding: 0;
            display: flex;
            justify-content: center;
            margin-top: 50px;
            margin-bottom: 100px;
          "
        >
          <div style="width: 1000px">
            <!-- PC端正方形网格布局 - 4列 -->
            <div class="square-grid">
              <div
                v-for="(item, index) in picUrlArr"
                :key="index"
                class="square-item"
              >
                <div v-if="item.type === 'image'" class="media-item">
                  <el-image
                    :src="item.FilePath"
                    :preview-src-list="[item.FilePath]"
                    fit="cover"
                    class="media-content"
                  />
                </div>
                <div v-else-if="item.type === 'video'" class="media-item">
                  <video
                    @click="toggleFullscreen"
                    playsinline
                    webkit-playsinline
                    class="media-content"
                  >
                    <source :src="item.FilePath" type="video/mp4" />
                    您的浏览器不支持视频播放
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部导航 -->
      <footer class="header-navbar">
        <div class="top-nav" style="height: 28px !important;">
          <div class="logo-container">
            <div class="logo">
              <img
                style="height: 28px !important"
                src="../assets/Battertimg/PC/Batteryplantlogo.png"
                alt=""
              />
            </div>
          </div>

          <div class="nav-items">
            <div class="nav-item" @click="goto('HOME')">HOME</div>
            <div class="nav-item" @click="goto('PROJECT')">ABOUT US</div>
            <div class="nav-item" @click="goto('PRODUCTS')">PRODUCTS</div>
            <div class="nav-item" @click="goto('CASE')">CASE</div>
            <div class="nav-item" @click="goto('CONTACTUS')">CONTACT US</div>
            <div class="nav-item" @click="goto('CONTACTUS')">BOOK NOW</div>
          </div>
        </div>
        <div style="height: 1px; background-color: #cccccc;margin-top:15px;margin-bottom:18px;"></div>
        <div>
          <div class="email-content">(04) 5245 7579</div>
          <div class="email-content">info@batteryplant.com.au</div>
          <div class="email-content">
            203 Blackburn Rd Mount Waverley VIC 3149
          </div>
        </div>
      </footer>
    </div>
    <div
      v-else
      style="
        width: 100%;
        border: 1px solid #f8f9fa;
        overflow: hidden;
        position: relative;
        background: white;
      "
    >
      <div style="position: relative">
        <img
          style="width: 100%"
          src="../assets/Battertimg/H5/casetop.jpg"
          alt=""
        />
        <div
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white !important;
            text-align: center;
            z-index: 10;
            width: 100%;
          "
        >
          <div
            style="
              font-size: 28px;
              font-family: Cotyledon-Regular-bold;
              line-height: 1;
              margin-bottom: 8px;
              width: 100%;
              text-align: center;
            "
          >
            Case
          </div>
        </div>
      </div>
      <!-- 移动端正方形循环布局 - 3列 -->
      <div
        style="
          width: 100%;
          padding-left: 10px;
          padding-right: 10px;
          margin-top: 30px;
          margin-bottom: 30px;
        "
      >
        <div class="mobile-square-grid">
          <div
            v-for="(item, index) in picUrlArr"
            :key="index"
            class="mobile-square-item"
          >
            <div v-if="item.type === 'image'" class="media-item">
              <el-image
                :src="item.FilePath"
                :preview-src-list="[item.FilePath]"
                fit="cover"
                class="media-content"
              />
            </div>
            <div v-else-if="item.type === 'video'" class="media-item">
              <video
                @click="toggleFullscreen"
                playsinline
                webkit-playsinline
                class="media-content"
              >
                <source :src="item.FilePath" type="video/mp4" />
                您的浏览器不支持视频播放
              </video>
            </div>
          </div>
        </div>
      </div>

      <footer class="mobile-footer-navbar">
        <div class="vertical-container">
          <div class="logo-section">
            <div class="logo-container">
              <div class="logo">
                <img
                  style="height: 28px !important"
                  src="../assets/Battertimg/PC/Batteryplantlogo.png"
                  alt="Battery Plant Logo"
                />
              </div>
            </div>
          </div>

          <div class="nav-section">
            <div
              class="nav-item"
              :class="{ active: activeNav === 0 }"
              @click="
                activateNav(0);
                goto('HOME');
              "
            >
              HOME
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 1 }"
              @click="
                activateNav(1);
                goto('PROJECT');
              "
            >
              ABOUT US
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 2 }"
              @click="
                activateNav(2);
                goto('PRODUCTS');
              "
            >
              PRODUCTS
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 3 }"
              @click="
                activateNav(3);
                goto('CASE');
              "
            >
              CASE
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 4 }"
              @click="
                activateNav(4);
                goto('CONTACTUS');
              "
            >
              CONTACT US
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 5 }"
              @click="
                activateNav(5);
                goto('CONTACTUS');
              "
            >
              BOOK NOW
            </div>
          </div>
          <div style="height: 1px; background-color: #cccccc"></div>
          <div class="contact-section">
            <div class="email-contentmobile">(04) 5245 7579</div>
            <div class="email-contentmobile">
              info@batteryplant.com.au
            </div>
            <div class="email-contentmobile">
              203 Blackburn Rd Mount Waverley VIC 3149
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { get, post } from "../assets/api/api";
import { CasePageList } from "../assets/api/request.js";
export default {
  props: {
    offsetwidth: {
      type: Number,
    },
  },
  data() {
    return {
      activeNav: null,
      imageList: [],
      picUrlArr: [],
    };
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    this.getCasePageList();
  },
  methods: {
    toggleFullscreen(event) {
      const video = event.target;
      if (video.paused) {
        video.play().catch((e) => console.log("播放失败:", e));
      } else {
        video.pause();
      }

      if (document.fullscreenEnabled) {
        if (!document.fullscreenElement) {
          video.requestFullscreen().catch((e) => {
            console.error("全屏失败:", e);
          });
        } else {
          document.exitFullscreen();
        }
      }
    },
    addTypeToMediaItems(data) {
      return data.map((item) => {
        let type = "unknown";

        try {
          if (item.FileFormat) {
            if (item.FileFormat.startsWith("image/")) {
              type = "image";
            } else if (item.FileFormat.startsWith("video/")) {
              type = "video";
            } else {
              const fileName = item.FileName || "";
              const extension = fileName.split(".").pop().toLowerCase();
              const imageExtensions = [
                "jpg",
                "jpeg",
                "png",
                "gif",
                "bmp",
                "webp",
                "svg",
              ];
              const videoExtensions = [
                "mp4",
                "avi",
                "mov",
                "wmv",
                "flv",
                "webm",
                "mkv",
              ];

              if (imageExtensions.includes(extension)) {
                type = "image";
              } else if (videoExtensions.includes(extension)) {
                type = "video";
              }
            }
          }
        } catch (error) {
          console.warn("处理文件类型时出错:", error, item);
        }

        return {
          ...item,
          type: type,
        };
      });
    },
    getCasePageList() {
      get(CasePageList).then((res) => {
        if (res.data.code == 200) {
          if (res.data.case.length !== 0) {
            const result = this.addTypeToMediaItems(res.data.case);
            this.picUrlArr = result;
          }
        }
      });
    },
    loadImages() {
      // 图片加载逻辑
    },
    handleImageClick(index) {
      this.$nextTick(() => {
        const viewer = document.querySelector(".el-image-viewer");
        if (viewer) {
          this.autoZoom(viewer);
          setTimeout(() => {
            const img = viewer.querySelector(".el-image-viewer__img");
            if (img) {
              img.style.transform = "scale(1.5)";
            }
          }, 50);
        }
      });
    },
    autoZoom(viewer) {
      const zoomInBtn = viewer.querySelector(".el-image-viewer__zoom-in");
      if (zoomInBtn) {
        zoomInBtn.click();
        setTimeout(() => zoomInBtn.click(), 30);
      }
    },
    activateNav(index) {
      this.activeNav = index;
    },
    goto(name) {
      if (name == "HOME") {
        window.sessionStorage.setItem("activeIndexh5", "/index");
        this.$router.push("/index");
      } else if (name == "PROJECT") {
        window.sessionStorage.setItem("activeIndexh5", "/Project");
        this.$router.push("/Project");
      } else if (name == "PRODUCTS") {
        window.sessionStorage.setItem("activeIndexh5", "/Productslist");
        this.$router.push("/Productslist");
      } else if (name == "CASE") {
        window.sessionStorage.setItem("activeIndexh5", "/Case");
        document.documentElement.scrollTop = 0;
      } else if (name == "CONTACTUS") {
        window.sessionStorage.setItem("activeIndexh5", "/ContactUs");
        this.$router.push("/ContactUs");
      }
    },
  },
};
</script>

<style>
.fullscreen-fallback {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  background: black;
}
</style>

<style scoped>
/* PC端正方形网格布局 - 4列 */
.square-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  width: 100%;
}

/* PC端正方形项目 - 固定尺寸 */
.square-item {
  width: 100%;
  height: 250px; /* PC端固定高度 */
  border-radius: 12px;
  overflow: hidden;
}

/* 移动端正方形网格布局 - 3列 */
.mobile-square-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  width: 100%;
}

/* 移动端正方形项目 - 固定尺寸 */
.mobile-square-item {
  width: 100%;
  height: 120px; /* 移动端固定高度 */
  border-radius: 12px;
  overflow: hidden;
}

/* 媒体项通用样式 */
.media-item {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  background-color: #f5f7fa;
}

.media-content {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持图片比例并填充容器 */
  border-radius: 12px;
}

/* 响应式适配 */
/* PC端响应式调整 */
@media (max-width: 1200px) {
  .square-grid {
    gap: 15px;
  }
  .square-item {
    height: 220px; /* 中等屏幕调整高度 */
  }
}

@media (max-width: 992px) {
  .square-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }
  .square-item {
    height: 200px; /* 小屏幕调整高度 */
  }
}

/* 移动端响应式调整 */
/* 超小屏手机 (iPhone 5/SE) 320px */
@media (max-width: 320px) {
  .mobile-square-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 5px;
  }
  .mobile-square-item {
    height: 90px; /* 超小屏调整高度 */
  }
}

/* 小屏手机 321px-375px */
@media (min-width: 321px) and (max-width: 375px) {
  .mobile-square-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
  }
  .mobile-square-item {
    height: 100px; /* 小屏调整高度 */
  }
}

/* 中屏手机 (iPhone 6/7/8/X) 376px-414px */
@media (min-width: 376px) and (max-width: 414px) {
  .mobile-square-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 7px;
  }
  .mobile-square-item {
    height: 110px; /* 中屏调整高度 */
  }
}

/* 大屏手机 415px-480px */
@media (min-width: 415px) and (max-width: 480px) {
  .mobile-square-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }
  .mobile-square-item {
    height: 120px; /* 大屏调整高度 */
  }
}

/* 小屏平板 481px-768px */
@media (min-width: 481px) and (max-width: 768px) {
  .mobile-square-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }
  .mobile-square-item {
    height: 140px; /* 平板调整高度 */
  }
}

/* 平板设备 769px-850px */
@media (min-width: 769px) and (max-width: 850px) {
  .mobile-square-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
  }
  .mobile-square-item {
    height: 150px; /* 大平板调整高度 */
  }
}

/* 确保视频控件样式一致 */
video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 播放按钮定位优化 */
.video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

/* 其他原有样式保持不变 */
.image-row {
  margin: 0;
}

.image-col {
  padding: 0;
}

.image-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  margin: 0;
  padding: 0;
}

.image-container > el-image {
  flex: 0 0 calc(50% - 0px);
  box-sizing: border-box;
}

.vc_custom_1627269981297copy {
  padding-top: 50px !important;
  padding-bottom: 40px !important;
  background-color: #84b903 !important;
}

.banner-text {
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translateY(-50%);
  color: white;
  text-align: left;
  z-index: 10;
}

.text-line-1 {
  font-size: clamp(24px, 3vw, 48px);
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 8px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.text-line-2 {
  font-size: clamp(18px, 2.2vw, 36px);
  font-weight: 600;
  line-height: 1.2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .banner-text {
    left: 8%;
  }
}

@media (max-width: 992px) {
  .banner-text {
    left: 6%;
  }
}

@media (max-width: 768px) {
  .banner-text {
    left: 5%;
  }

  .text-line-1 {
    font-size: clamp(20px, 4vw, 32px);
  }

  .text-line-2 {
    font-size: clamp(16px, 3vw, 24px);
  }
}

/* 导航栏样式 */
.header-navbar {
  padding: 20px 40px;
  background-color: white;
}

.top-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-container {
  flex-shrink: 0;
}

.logo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logo-icon {
  font-size: 24px;
}

.logo-text {
  font-size: 18px;
  font-weight: 600;
}

.nav-items {
  display: flex;
  gap: 30px;
}

.nav-item {
  font-size: 14px;
  font-weight: bold;
  color: #666666;
  cursor: pointer;
  transition: all 0.3s;
  padding: 5px 0;
  position: relative;
  border-bottom: 2px solid transparent;
}

.nav-item:hover,
.nav-item.active {
  color: #0c80da !important;
}

.email-info {
  margin-top: 30px;
}

.email-content {
  font-size: 12px;
  color: #666;
  text-align: right;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .top-nav {
    flex-direction: column;
    gap: 20px;
  }

  .nav-items {
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
  }

  .email-content {
    text-align: center;
  }
}

/* 移动端底部导航栏样式 */
.mobile-footer-navbar {
  background-color: white;
  padding: 20px;
}

.vertical-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.logo-section,
.nav-section,
.contact-section {
  text-align: left;
}

.logo-container {
  margin-bottom: 10px;
}

.nav-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.nav-item {
  font-size: 14px;
  font-weight: bold;
  color: #666666;
  cursor: pointer;
  transition: all 0.3s;
  padding: 5px 0;
  position: relative;
  border-bottom: 2px solid transparent;
}

.nav-item:hover,
.nav-item.active {
  color: #0c80da !important;
}

.contact-section {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.email-contentmobile {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
}

@media (max-width: 480px) {
  .vertical-container {
    gap: 15px;
  }

  .nav-section {
    gap: 2px;
  }

  .nav-item {
    font-size: 14px;
    font-weight: bold;
  }

  .email-contentmobile {
    font-size: 12px;
  }
}
</style>